import { RefObject } from 'react'
import useKeys from './useKeys'
import { KeyCodes } from 'frontend/enums'

const useFocusOutside = (ref: RefObject<HTMLElement>, callback: () => void) => {
  const handleTabKey = (e: KeyboardEvent) => {
    const focusableModalElements = ref.current?.querySelectorAll(
      'a[href]:not([data-hidden-in-tabtrap]), button, textarea, input[type="text"]:enabled, input[type="radio"]:enabled, input[type="checkbox"]:enabled, select:enabled',
    )

    if (!focusableModalElements) return

    const firstElement = focusableModalElements[0] as HTMLElement
    const lastElement = focusableModalElements[
      focusableModalElements.length - 1
    ] as HTMLElement

    const isTabingForward = !e.shiftKey
    const isTabingBackward = e.shiftKey

    if (isTabingForward && document.activeElement === lastElement) {
      callback()
      e.preventDefault()
    }

    if (isTabingBackward && document.activeElement === firstElement) {
      callback()
      e.preventDefault()
    }
  }

  useKeys(
    true,
    {
      [KeyCodes.ESCAPE_KEY]: callback,
      [KeyCodes.TAB_KEY]: handleTabKey,
    },
    false,
  )
}

export default useFocusOutside
